import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const baseURL = process.env.PUBLIC_URL + '/assets/Gallery/';
const baseURL2 = process.env.PUBLIC_URL + '/assets/';

const CustomSlider = ({ images, title, imageWidth , imageHeight}) => {
  const sliderRef = useRef(null);
  const [aspectRatio, setAspectRatio] = useState(null);

  useEffect(() => {
    // Calculate aspect ratio of the first image
    const firstImage = new Image();
    firstImage.src = `${baseURL}${images[0]}`;
    firstImage.onload = () => {
      const ratio = firstImage.width / firstImage.height;
      setAspectRatio(ratio);
    };
  }, [images]);

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0",
    speed: 500,
    slidesToShow: 3,
    nextArrow: <></>,
    prevArrow: <></>,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };

  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  return (
    <div className="relative">
      <button
        className="absolute lg:ml-20 top-1/2 transform -translate-y-1/2 bg-transparent border-none focus:outline-none"
        style={{ left: "3%", zIndex: 10 , top:"60%"  }} // Adjusted zIndex to ensure buttons are above the image
        onClick={handlePrev}
      >
        <img
          loading="lazy"
          src={`${baseURL2}/leftgal.svg`}         
          className="w-16 h-16"
          alt="Left Arrow"
        />
      </button>
      
      <p className="text-3xl font-bold tracking-wider text-black capitalize ml-4 sm:ml-44">{title}</p>
      <div className="mt-8 m-60 max-sm:m-16 mb-20 relative z-0">
        {aspectRatio && (
          <Slider {...settings} ref={sliderRef}>
            {images.map((image, index) => (
              <div key={index} className="center-slide p-2">
                <img
                  src={`${baseURL}${image}`}
                  alt={`Image ${index + 1}`}
                  style={{ width: imageWidth, height:imageHeight }}
                />
              </div>
            ))}
          </Slider>
        )}
      </div>
      <button
        className="absolute lg:mr-20 top-1/2 transform -translate-y-1/2 bg-transparent border-none focus:outline-none "
        style={{ right: "3%", zIndex: 10 , top:"60%"}} // Adjusted zIndex to ensure buttons are above the image
        onClick={handleNext}
      >
        <img
          loading="lazy"
          src={`${baseURL2}/rightgal.svg`}         
          className="w-16 h-16"
          alt="Right Arrow"
        />
      </button>
    </div>
  );
};

export default CustomSlider;
